import { CancelTokenSource } from 'axios';

import { IShipmentStop } from '@rygen/rygen-ui/model';

import { ShipmentEvent, ShippingPoint, StopMileageResponse } from '@/model';
import { MapDetailsResponse } from '@/model/geocoding/MapDetailsResponse';

import { BaseHttpController } from './BaseHttpController';

export class RouteController extends BaseHttpController {
  static readonly ENDPOINT: string = 'route';

  constructor() {
    super(RouteController.ENDPOINT);
  }

  async findMileage(
    stops: ShippingPoint[],
    cancelToken?: CancelTokenSource,
  ): Promise<StopMileageResponse[]> {
    const response = await this.http.post<StopMileageResponse[]>(
      'find-mileage',
      { stops },
      { cancelToken: cancelToken?.token },
    );

    return response.data.map((m) => new StopMileageResponse(m));
  }

  async getMapDetails(
    stops: IShipmentStop[],
    events?: ShipmentEvent[],
    cancelToken?: CancelTokenSource,
  ): Promise<MapDetailsResponse> {
    const response = await this.http.post<MapDetailsResponse>(
      'map-details',
      { stops, events },
      { cancelToken: cancelToken?.token },
    );

    return new MapDetailsResponse(response.data);
  }
}
